import { render, staticRenderFns } from "./ModalSpecialist.vue?vue&type=template&id=773534be&"
import script from "./ModalSpecialist.vue?vue&type=script&lang=js&"
export * from "./ModalSpecialist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports